import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = []
